import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { HotelSummaryModel } from '@models/hotel';
import { LoadingService } from '@shared/services/loading.service';
import { HotelInfoUiService } from '../services/hotel-info-ui.service';
import { UtmService } from '@core/services/utm.service';

// export const hotelInfoResolver: ResolveFn<HotelSummaryModel> = (
export const hotelInfoResolver: ResolveFn<void | HotelSummaryModel> = (
 route: ActivatedRouteSnapshot,
 state: RouterStateSnapshot,
 hotelInfoUiService: HotelInfoUiService = inject(HotelInfoUiService),
 platformId: Object = inject(PLATFORM_ID),
 _loadingService = inject(LoadingService),
 utmService: UtmService = inject(UtmService)
) => {
 const params = route.params;
 const splittedCityName = params['city-name'].split('-');
 let CityName = '';

 // function parse(url: string): string {
 //   url = url.replace(/\(/g, '%28').replace(/\)/g, '%29');
 //   return url
 // }

 if (state.url.includes('ecolodge'))
  CityName = isPlatformServer(platformId)
   ? encodeURIComponent(params['city-name'])
   : params['city-name'];
 else {
  //we have a param like : mashad-hotels or torbat-e-heydarie-hotels ==> and we want to remove the hotels word from its end
  splittedCityName.pop();
  CityName = isPlatformServer(platformId)
   ? encodeURIComponent(splittedCityName.join('-'))
   : splittedCityName.join('-');
 }
 const { date, endDate } = route.queryParams;
 let hotelName = '';

 utmService.checkRouteParams(route.queryParamMap);

 if (isPlatformBrowser(platformId)) {
  hotelName = encodeURIComponent(params['resident-name'] as string);
  hotelInfoUiService.getHotelInfoSummary(
   CityName,
   hotelName,
   date,
   endDate,
   route.data['accommodation']
  );
 } else {
  hotelName = encodeURIComponent(
   (params['resident-name'] as string).replace(/%28/g, '(').replace(/%29/g, ')')
  );
  const summary$ = hotelInfoUiService.getHotelInfoSummary(
   CityName,
   hotelName,
   date,
   endDate,
   route.data['accommodation']
  );
  return summary$;
 }
};
